export const urlWithUtms = (baseUrl) => {
  if(baseUrl === null) baseUrl='https:www.getweave.com/';
  if (typeof sessionStorage !== `undefined`) {
    const utmSource = (sessionStorage.getItem('utm_source') !== null) ? sessionStorage.getItem('utm_source') : 'weaveconnected.com';
    const utmMedium = (sessionStorage.getItem('utm_medium') !== null) ? sessionStorage.getItem('utm_medium') : 'referral';
    const utmCampaign = (sessionStorage.getItem('utm_campaign') !== null) ? sessionStorage.getItem('utm_campaign') : 'lab'; //launch a business
    return baseUrl += '?utm_source='+utmSource+'&utm_medium='+utmMedium+'&utm_campaign='+utmCampaign;
  }
}
